let state = {
    SICUS_Catalogos_055Instituciones: {}
}

let getters = {
    Get_SICUS_Catalogos_055Instituciones: state => {
        return state.SICUS_Catalogos_055Instituciones;
    }
}

let mutations = {
    M_SICUS_Catalogos_Establecer055Institucion(state, data) {
        state.SICUS_Catalogos_055Instituciones[data.llave] = data.valor
    }
}

let actions = {
    A_SICUS_Catalogos_Establecer055Institucion: ({commit}, data) => {
        commit('M_SICUS_Catalogos_Establecer055Institucion', data)
    }
}

const SICUS = {
    State: state,
    Getters: getters,
    Mutations: mutations,
    Actions: actions
}
export default SICUS;


// WEBPACK FOOTER //
// ./src/store/SICUS.js